import React from 'react';
import { useParams } from 'react-router-dom';
import ProfilePageLayout from '../../../layouts/ProfilePageLayout/ProfilePageLayout';

interface IGenericProfilePageProps {}

const GenericProfilePage: React.FC<React.PropsWithChildren<IGenericProfilePageProps>> = ({}) => {
  const { profileId, storeSlug, categorySlug } = useParams<any>();

  const props = {
    fetchDataUrl: `/v1/@/${profileId}/${categorySlug}`,
    checkAvailabilityUrl: '',
    fetchMediaUrl: `/v1/media/?userProfileId=${profileId}&categorySlug=${categorySlug}`,
    mobileOrStudio: 'mobile' as 'mobile' | 'studio',
    offerKey: '',
    fetchReviewsUrl: `/v1/reviews/provider/${profileId}/category/${categorySlug}`,
    fetchTestimonialsUrl: `/v1/@/${profileId}/testimonials/category/${categorySlug}`,
  };

  return <ProfilePageLayout {...props} />;
};
export default GenericProfilePage;
